import user from '@/api/user';

const persistKey = 'popup-messages-shown';

function acknowledge(id) {
    user.acknowledgePopupMessage(
        this,
        id,
        () => {},
        error => {
            console.error('could not acknowledge popup message', error);
        },
        () => {},
    );
}

function showNext(vueModal, messages, index) {
    if (index >= messages.length) {
        return;
    }

    const message = messages[index];

    vueModal.show('dialog', {
        title: message.subject,
        text: message.body,
        buttons: [
            {
                title: 'Schließen',
                default: true,
                handler() {
                    vueModal.hide('dialog');
                    acknowledge(message.id);
                    showNext(vueModal, messages, index + 1);
                },
            },
        ],
    });
}

export default {
    showPopupMessagesIfNeeded(vueModal) {
        // Session-scoped, same as donate-modal.js -- once shown this session,
        // don't ask again until the next visit even if more arrive meanwhile.
        if (sessionStorage.getItem(persistKey) === '1') {
            return;
        }

        sessionStorage.setItem(persistKey, '1');

        user.getPopupMessages(
            this,
            data => {
                const messages = data.messages || [];
                showNext(vueModal, messages, 0);
            },
            error => {
                console.error('could not load popup messages', error);
            },
            () => {},
        );
    },
};
